<template>
  <div class="guarantor-edit">
    <Row :gutter="32">
      <i-col span="12">
        <router-view :data="guarantorModel" />
      </i-col>
    </Row>
    <Row :gutter="32">
      <i-col span="12">
        <Button type="primary" size="large" long @click="submit">提交</Button>
      </i-col>
      <i-col span="12" v-if="$common.userType[$store.getters.userInfo.type.toString()] === '保证人'">
        <Button type="warning" size="large" long @click="submitDraft">存草稿</Button>
      </i-col>
    </Row>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'">查看</a>
    </Modal>
  </div>
</template>

<script>
import Config from './../../../configs'
import Api from './../../api/Api.js'
export default {
  name: 'guarantor-edit',
  props: {
  },
  data () {
    return {
      loading: false,
      guarantorModel: {
        id: null,
        name: null,
        businessLicense: null,
        legalPersonName: null,
        corpType: null,
        type: null,
        businessTerm: null,
        contact: null,
        contactTel: null,
        regCity: null,
        address: null,
        email: null,
        postCode: null,
        capital: null,
        estDate: null,
        scope: null,
        homePage: null,
        fax: null,
        legalPersonID: null,
        legalPersonIDImgs: [],
        legalPersonRole: null,
        legalPersonTitle: null,
        generalManagerName: null,
        generalManagerRole: null,
        generalManagerTitle: null,
        employeeTotal: 0,
        titledTotal: 0,
        titledMedTotal: 0,
        titledSeniorTotal: 0,
        qualifiedTotal: 0,
        regSupervTotal: 0,
        regConstrTotal: 0,
        regCostTotal: 0,
        prjManagerTotal: 0,
        cpaTotal: 0,
        solicitorTotal: 0,
        introduction: null,
        guarRange: null,
        orgChartPath: '',
        attachments: null
      }
    }
  },
  watch: {
    '$route.params.guarantorId': function () {
      this.getGuarantorDetail()
    }
  },
  mounted () {
    this.getGuarantorDetail()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getConfig (key) {
      return Config(key)
    },
    getGuarantorDetail () {
      if (this.$route.query.own) {
        Api.Guarantor.getMyGuarantorDetail().then((res) => {
          Object.assign(this.guarantorModel, res)
          if (res.businessTerm === '长期') {
            this.longTerm = true
          } else {
            this.longTerm = false
          }
          let attaches = this.getConfig('guarantorRegisterAttachmentRequirements')
          if (attaches && attaches instanceof Array && attaches.length) {
            attaches.forEach((a) => {
              let att = this.guarantorModel.attachments.find(o => o.name === a.name)
              if (att) {
                Object.assign(att, {
                  formats: a.formats,
                  fileSizeLimit: a.fileSizeLimit,
                  fileCountLimit: a.fileCountLimit,
                  required: a.required
                })
              }
            })
          }
          this.$nextTick(() => {
            this.procAttachmentsOssKeys(this.guarantorModel.attachments)
          })
        }).catch(err => {
          this.$Message.error('获取详情失败!' + err.message)
        })
      } else {
        Api.Guarantor.getGuarantorDetail(this.$route.params.guarantorId).then((res) => {
          Object.assign(this.guarantorModel, res)
        }).catch(err => {
          this.$Message.error('获取详情失败!' + err.message)
        })
      }
    },
    async submit () {
      let formValid = false
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.$refs.attachmentForm.validate(async (valid2) => {
            formValid = valid2
          })
        }
      })
      if (formValid) {
        this.loading = true
        this.$Spin.show()
        let model = JSON.parse(JSON.stringify(this.guarantorModel))
        if (this.$route.query.own) {
          model.attachments.forEach((att) => {
            if (att.url instanceof Array) {
              att.url = att.url.map((u) => {
                return u.name.replace('oss:', '')
              }).join(',')
            }
          })
          await Api.Guarantor.reSubmitNewGuarantor(model)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('修改成功!')
              this.loading = false
              this.$Spin.hide()
              this.$router.push({path: '/guarantors/mydetail'})
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        } else {
          await Api.Guarantor.updateGuarantor(model)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('修改成功!')
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      }
    },
    async submitDraft () {
      this.loading = true
      this.$Spin.show()
      let payload
      if (this.$common.userType[this.$store.getters.userInfo.type.toString()] === '保证人') {
        let model = JSON.parse(JSON.stringify(this.guarantorModel))
        if (!model.estDate) {
          model.estDate = null
        }
        if (this.$route.query.own) {
          model.attachments.forEach((att) => {
            if (att.url instanceof Array) {
              att.url = att.url.map((u) => {
                return u.name.replace('oss:', '')
              }).join(',')
            }
          })
        }
        payload = await Api.Guarantor.submitDraft(model)
          .catch(err => {
            console.log('err', err)
            this.$Message.error('提交失败!' + err.message)
            this.loading = false
            this.$Spin.hide()
          })
      }
      if (payload) {
        console.log('suc', payload)
        this.$Message.success('保存成功!')
        this.loading = false
        this.$Spin.hide()
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>
